import Link from 'next/link'
import { ReactNode } from 'react'

type Props = {
  href: string
  onNavigate?: (_event: { preventDefault: () => void }) => void
  children: ReactNode
  icon?: ReactNode
  className?: string
}

const SecondaryLink: React.FC<Props> = ({
  href,
  onNavigate,
  children,
  icon,
  className = '',
}) => {
  return (
    <Link
      href={href}
      onNavigate={onNavigate}
      className={`flex items-center justify-center gap-2 py-3.5 px-4 rounded-xl border border-main bg-main text-sm font-bold text-main active:scale-[0.98] transition-all shadow-sm hover:bg-surface-subtle ${className}`}
    >
      {icon}
      {children}
    </Link>
  )
}

export default SecondaryLink
